/**
 * Suggestions Panel Component
 *
 * Displays suggested queries as horizontal chips.
 * - variant="starter": pre-query chips with Compass icon (up to 6)
 * - variant="followup": post-query chips with Sparkles icon (up to 4)
 */

import React from 'react';
import { Stack, Chip } from '@mui/material';
import { Sparkles, Compass } from 'lucide-react';

const SuggestionsPanel = ({ suggestions, onSuggestionClick, variant = 'followup' }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const Icon = variant === 'starter' ? Compass : Sparkles;
  const maxItems = variant === 'starter' ? 6 : 4;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        py: 1,
        px: 2,
        overflowX: 'auto',
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': {
          bgcolor: 'divider',
          borderRadius: 2,
        },
      }}
    >
      <Icon size={14} style={{ flexShrink: 0, color: 'rgba(255,255,255,0.5)' }} />
      {suggestions.slice(0, maxItems).map((suggestion, idx) => (
        <Chip
          key={idx}
          label={suggestion}
          variant="outlined"
          size="small"
          onClick={() => onSuggestionClick(suggestion)}
          sx={{
            flexShrink: 0,
            borderColor: 'divider',
            color: 'text.secondary',
            fontSize: '0.75rem',
            '&:hover': {
              borderColor: 'primary.main',
              color: 'text.primary',
              bgcolor: 'action.hover',
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default SuggestionsPanel;
